import React from 'react'

function New() {
    return (
        <div style={{ width: "45px", fontSize: "18px", borderRadius: "10px", backgroundColor: "#f80a0aac", color: "white", display: "grid", placeContent: "center center" }}>
            <span><strong>New</strong></span>
        </div>
    )
}

export default New
